module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header"
  }, [_c('div', {
    staticClass: "gheader-fix"
  }, [_c('app-header')], 1), (_vm.stepUpGetEnd && _vm.magazineCallbackFlag) ? _c('div', {
    staticClass: "container bg01 home"
  }, [(_vm.documentRenewalCount > 0) ? _c('div', {
    staticClass: "row home__sec"
  }, [_c('section', {
    staticClass: "home__section__2"
  }, [_vm._m(0), _c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_c('p', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "padding-left": "0px"
    }
  }, [_vm._v("期限が近づいている書類、または期限日が未登録の書類が\n" + _vm._s(_vm.documentRenewalCount) + "件あります。")]), _vm._m(1), _c('button', {
    staticClass: "btn01 -home-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goDocumentRenewalList
    }
  }, [_c('span', [_vm._v("書類の更新をお願いします")])])])])]) : _vm._e(), (_vm.isStepUpExist) ? _c('div', {
    staticClass: "row home__sec"
  }, [_c('section', {
    staticClass: "home__section__4"
  }, [_vm._m(2), (_vm.watchStepUps.data.length > 0) ? _c('div', [_c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_vm._m(3), _c('div', {
    staticClass: "mt15"
  }, [_vm._l((_vm.watchStepUps.data), function(watchStepUp) {
    return _c('div', {
      staticClass: "home__step-up__content-member"
    }, [_c('button', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "gheader__menu-body__head__img"
    }, [(watchStepUp.attributes['profile-image']) ? _c('div', [_c('img', {
      attrs: {
        "src": watchStepUp.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png")
      }
    })])]), _c('div', {
      staticClass: "home__step-up__content-member-text"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(watchStepUp.attributes['user-name-format']))]), _c('div', {
      staticClass: "date"
    }, [_vm._v("評価期間：" + _vm._s(watchStepUp.attributes['answer-start-date-format']) + " 〜 " + _vm._s(watchStepUp.attributes['end-date-format']))])])])])
  }), _c('div', {
    staticClass: "home__step-up__content-button"
  }, [_c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": function($event) {
        _vm.goStepUpQuestionCheck('stepup')
      }
    }
  }, [_c('span', [_vm._v("評価項目を確認する")])])])], 2)])]) : _vm._e()]), (_vm.nowStepUps.data.length > 0 || _vm.isStepUpCallExist) ? _c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_c('p', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "padding-left": "0px"
    }
  }, [_vm._v("評価シートの回答をお願いします。")]), (_vm.isStepUpCallExist) ? _c('div', {
    staticClass: "mt15"
  }, [_c('div', [_c('p', {
    staticClass: "home__2__txt2"
  }, [_vm._v("店舗長の方と事務の方は、まだ回答が済んでいない方への声かけをお願いします。")]), _c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": function($event) {
        _vm.goStepUpCallList()
      }
    }
  }, [_c('span', [_vm._v("声かけリスト(未回答の方一覧)")])])])]) : _vm._e(), _vm._l((_vm.nowStepUps.data), function(nowStepUp) {
    return _c('div', {
      staticClass: "mt15"
    }, [_c('div', {
      staticClass: "home__step-up__content-member"
    }, [_c('button', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "gheader__menu-body__head__img"
    }, [(nowStepUp.attributes['profile-image']) ? _c('div', [_c('img', {
      attrs: {
        "src": nowStepUp.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png")
      }
    })])]), _c('div', {
      staticClass: "home__step-up__content-member-text"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(nowStepUp.attributes['user-name-format']))]), _c('div', {
      staticClass: "date deadline"
    }, [_vm._v("評価〆切：〜 " + _vm._s(nowStepUp.attributes['end-date-format']))])]), _c('div', {
      staticClass: "home__step-up__content-member-button"
    }, [_c('button', {
      staticClass: "btn04 -home-style",
      on: {
        "click": function($event) {
          _vm.goStepUpAnswerClick(nowStepUp.id)
        }
      }
    }, [_c('span', [_vm._v("評価シートに回答する")])])])])])])
  })], 2) : _vm._e(), (!_vm.isStepUpCallExist && (_vm.isShopMaster || _vm.isClerk)) ? _c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_vm._m(4)]) : _vm._e(), (_vm.onceEndStepUps.data.length > 0) ? _c('div', {
    staticClass: "home__step-up__content answered"
  }, [_c('div', {
    staticClass: "text",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_vm._v("期間中は何度でも再提出が可能です。")]), _c('div', {
    staticClass: "home__step-up__content-member"
  }, _vm._l((_vm.onceEndStepUps.data), function(onceEndStepUp) {
    return _c('div', {
      staticClass: "mt15"
    }, [_c('button', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "gheader__menu-body__head__img"
    }, [(onceEndStepUp.attributes['profile-image']) ? _c('div', [_c('img', {
      attrs: {
        "src": onceEndStepUp.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png")
      }
    })])]), _c('div', {
      staticClass: "home__step-up__content-member-text"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(onceEndStepUp.attributes['user-name-format']))]), _c('div', {
      staticClass: "date deadline"
    }, [_vm._v("評価〆切：〜 " + _vm._s(onceEndStepUp.attributes['end-date-format']))])]), _c('div', {
      staticClass: "home__step-up__content-member-button"
    }, [_c('button', {
      staticClass: "btn01 -home-style",
      on: {
        "click": function($event) {
          _vm.goStepUpAnswerList(onceEndStepUp.id)
        }
      }
    }, [_vm._m(5, true), _c('span', [_vm._v("内容を確認する")])])])])])
  }), 0)]) : _vm._e()]) : _vm._e(), (_vm.evaluateAnswerGetEnd && _vm.isEvaluateAnswerExist) ? _c('div', {
    staticClass: "row home__sec"
  }, [_c('section', {
    staticClass: "home__section__4"
  }), _vm._m(6), (_vm.watchEvaluateAnswers.data.length > 0) ? _c('div', [_c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_c('p', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "padding-left": "0px"
    }
  }, [_vm._v("人事評価対象のスタッフがいます。")]), _vm._l((_vm.watchEvaluateAnswers.data), function(watchEvaluateAnswer) {
    return _c('div', {
      staticClass: "mt15"
    }, [_c('div', {
      staticClass: "home__step-up__content-member"
    }, [_c('button', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "gheader__menu-body__head__img"
    }, [(watchEvaluateAnswer.attributes['profile-image']) ? _c('div', [_c('img', {
      attrs: {
        "src": watchEvaluateAnswer.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _vm._e(), _vm._m(7, true)]), _c('div', {
      staticClass: "home__step-up__content-member-text"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(watchEvaluateAnswer.attributes['user-name-format']))]), _c('div', {
      staticClass: "date"
    }, [_vm._v("評価期間：" + _vm._s(watchEvaluateAnswer.attributes['answer-start-date-format']) + " 〜 " + _vm._s(watchEvaluateAnswer.attributes['end-date-format']))])])])]), _c('div', {
      staticClass: "home__step-up__content-button"
    }, [_c('button', {
      staticClass: "btn02 -home-style",
      on: {
        "click": function($event) {
          _vm.goEvaluateQuestionCheck(watchEvaluateAnswer.id)
        }
      }
    }, [_c('span', [_vm._v("評価項目を確認する")])])])])
  })], 2)]) : _vm._e(), (_vm.nowEvaluateAnswers.length) ? _c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_c('p', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "padding-left": "0px"
    }
  }, [_vm._v("評価シートの回答をお願いします。")]), (_vm.isEvaluateAnswerCallExist) ? _c('div', {
    staticClass: "mt15"
  }, [_c('div', [_c('p', {
    staticClass: "home__2__txt2"
  }, [_vm._v("店舗長の方と事務の方は、まだ回答が済んでいない方への声かけをお願いします。")]), _c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": function($event) {
        _vm.goEvaluateAnswerCallList()
      }
    }
  }, [_c('span', [_vm._v("声かけリスト(未回答の方一覧)")])])])]) : _vm._e(), _vm._l((_vm.nowEvaluateAnswers), function(nowEvaluateAnswer) {
    return _c('div', {
      staticClass: "mt15"
    }, [_c('div', {
      staticClass: "home__step-up__content-member"
    }, [_c('button', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "gheader__menu-body__head__img"
    }, [(nowEvaluateAnswer.attributes['profile-image']) ? _c('div', [_c('img', {
      attrs: {
        "src": nowEvaluateAnswer.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div'), _vm._m(8, true)]), _c('div', {
      staticClass: "home__step-up__content-member-text"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(nowEvaluateAnswer.attributes['user-name-format']))]), _c('div', {
      staticClass: "date deadline"
    }, [_vm._v("評価〆切：〜 " + _vm._s(nowEvaluateAnswer.attributes['answer-end-date-format']))])]), _c('div', {
      staticClass: "home__step-up__content-member-button"
    }, [_c('button', {
      staticClass: "btn04 -home-style",
      on: {
        "click": function($event) {
          _vm.goEvaluateAnswerClick(nowEvaluateAnswer.id)
        }
      }
    }, [_c('span', [_vm._v("評価シートに回答する")])])])])])])
  })], 2) : _vm._e(), (!_vm.isEvaluateAnswerCallExist && (_vm.isShopMaster || _vm.isClerk)) ? _c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_vm._m(9)]) : _vm._e(), (_vm.onceEndEvaluateAnswers.data.length > 0) ? _c('div', {
    staticClass: "home__step-up__content answered"
  }, [_c('div', {
    staticClass: "text",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_vm._v("期間中は何度でも再提出が可能です。")]), (!_vm.nowEvaluateAnswers.length && _vm.isEvaluateAnswerCallExist) ? _c('div', {
    staticClass: "mt15"
  }, [_c('div', [_c('p', {
    staticClass: "home__2__txt2"
  }, [_vm._v("店舗長の方と事務の方は、まだ回答が済んでいない方への声かけをお願いします。")]), _c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": function($event) {
        _vm.goEvaluateAnswerCallList()
      }
    }
  }, [_c('span', [_vm._v("声かけリスト(未回答の方一覧)")])])])]) : _vm._e(), _c('div', {
    staticClass: "home__step-up__content-member"
  }, _vm._l((_vm.onceEndEvaluateAnswers.data), function(onceEndEvaluateAnswer) {
    return _c('div', {
      staticClass: "mt15"
    }, [_c('button', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "gheader__menu-body__head__img"
    }, [(onceEndEvaluateAnswer.attributes['profile-image']) ? _c('div', [_c('img', {
      attrs: {
        "src": onceEndEvaluateAnswer.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png")
      }
    })])]), _c('div', {
      staticClass: "home__step-up__content-member-text"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(onceEndEvaluateAnswer.attributes['user-name-format']))]), _c('div', {
      staticClass: "date deadline"
    }, [_vm._v("評価〆切：〜 " + _vm._s(onceEndEvaluateAnswer.attributes['end-date-format']))])]), _c('div', {
      staticClass: "home__step-up__content-member-button"
    }, [_c('button', {
      staticClass: "btn01 -home-style",
      on: {
        "click": function($event) {
          _vm.goEvaluateAnswerList(onceEndEvaluateAnswer.id)
        }
      }
    }, [_vm._m(10, true), _c('span', [_vm._v("内容を確認する")])])])])])
  }), 0)]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "row home__sec"
  }, [_c('section', {
    staticClass: "home__section__4"
  }, [_vm._m(11), _c('div', {
    staticClass: "home__sec__inner home__5"
  }, [_vm._m(12), _c('button', {
    staticClass: "btn01 -home-style -card-write",
    on: {
      "click": _vm.goEsMycardSelectDesign
    }
  }, [_c('span', [_vm._v("カードを書く")])]), (_vm.isEsmycardDay) ? _c('div', [_c('div', {
    staticClass: "es_mycard_btn"
  }, [_vm._m(13), _c('div', [_c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": _vm.goEsMycardList
    }
  }, [_c('span', [_vm._v("ESmyカード一覧へ")])])])]), _c('img', {
    staticClass: "card_pop margin-top",
    attrs: {
      "src": require("../images/esmycard_pop.jpg")
    },
    on: {
      "click": _vm.goEsMycardList
    }
  })]) : _c('div', {
    staticClass: "es_mycard_wrap",
    class: {
      unread: _vm.card.is_already_read
    }
  }, [_c('div', {
    staticClass: "es_mycard_btn"
  }, [_vm._m(14), _c('div', [_c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": _vm.goEsMycardList
    }
  }, [_c('span', [_vm._v("ESmyカード一覧へ")])])])]), (_vm.card.id !== null) ? _c('div', {
    staticClass: "es_mycard_content"
  }, [_vm._m(15), _c('div', {
    staticClass: "es_mycard",
    on: {
      "click": function($event) {
        _vm.goEsMycardDetail(_vm.card.id)
      }
    }
  }, [_c('div', {
    staticClass: "es_mycard_background"
  }, [(_vm.card.is_facing_type) ? [_c('img', {
    attrs: {
      "src": _vm.getFrontImageByPath(_vm.card.front_card_image)
    }
  })] : [_c('img', {
    attrs: {
      "src": _vm.getBackgroundImageByImageName(_vm.card.background_path)
    }
  })]], 2), _vm._m(16), _vm._m(17), _c('div', {
    staticClass: "users_box",
    class: {
      '-facing-card': _vm.card.is_facing_type
    }
  }, [_c('div', {
    staticClass: "get_user_box"
  }, [_c('div', {
    staticClass: "get_user_box_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getUserImage(_vm.card.get_user_image)
    }
  })]), _c('div', {
    staticClass: "get_user_box_body"
  }, [_c('p', {
    staticClass: "get_user_box_body-role"
  }, [_vm._v(_vm._s(_vm.card.get_user_shop_name))]), _c('p', {
    staticClass: "get_user_box_body-name"
  }, [_vm._v(_vm._s(_vm.card.get_user_name))])])]), _c('div', {
    staticClass: "give_user_box"
  }, [_c('div', {
    staticClass: "give_user_box_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getUserImage(_vm.card.give_user_image)
    }
  })]), _c('div', {
    staticClass: "give_user_box_body"
  }, [_c('p', {
    staticClass: "give_user_box_body-role"
  }, [_vm._v(_vm._s(_vm.card.give_user_shop_name))]), _c('p', {
    staticClass: "give_user_box_body-name"
  }, [_vm._v(_vm._s(_vm.card.give_user_name))])])])]), (!_vm.card.is_facing_type) ? _c('div', {
    staticClass: "comment_box"
  }, [_c('div', {
    staticClass: "comment_box_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getCharacter1ImageByImageName(_vm.card.character_1_folder_path, _vm.card.character_1_path)
    }
  })]), _c('div', {
    staticClass: "comment_box_body"
  }, [_c('p', {
    staticClass: "comment_box_body-text"
  }, [_vm._v(_vm._s(_vm._f("stringTtruncate")(_vm.card.comments)))])])]) : _vm._e()])]) : _vm._e()])])]), _c('section', {
    staticClass: "home__section__1"
  }, [_vm._m(18), _c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_vm._m(19), _c('button', {
    staticClass: "btn01 -home-style",
    on: {
      "click": _vm.goProposeAllshopList
    }
  }, [_c('span', [_vm._v("提案する・みんなの提案を見る")])]), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "mt15"
  }, [_c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": function($event) {
        _vm.goFrontUrl('/#/propose_unapproved_list')
      }
    }
  }, [_c('span', [_vm._v("提出された提案の一覧画面へ")])])]) : _vm._e()])]), _c('section', {
    staticClass: "home__section__2"
  }, [_vm._m(20), _c('div', {
    staticClass: "home__sec__inner home__5"
  }, [_vm._m(21), _c('button', {
    staticClass: "btn01 -home-style",
    class: _vm.requestHolidayUnavailable(),
    attrs: {
      "disabled": _vm.noRequestHoliday()
    },
    on: {
      "click": _vm.goRequestHolidayNew
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.requestHolidayWordBox)
    }
  }, [_vm._v("希望休を提出する")])]), _vm._m(22), _c('div', [_c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": _vm.goShiftList
    }
  }, [_vm._m(23)])])])]), _c('section', {
    staticClass: "home__section__3"
  }, [_vm._m(24), (_vm.magazineCallbackFlag) ? _c('div', {
    staticClass: "home__sec__inner home__6"
  }, [_c('div', {
    staticClass: "home__6__wrap"
  }, [_c('div', {
    staticClass: "home__6__wrap__content"
  }, [_c('img', {
    attrs: {
      "src": _vm.magazines[0].attributes['magazine-picture-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    },
    on: {
      "click": function($event) {
        _vm.goMagazinePdf(_vm.magazines[0].attributes['magazine-pdf-path'])
      }
    }
  })])]), _c('div', {
    staticClass: "mt15"
  }, [_c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": function($event) {
        _vm.goMagagineList()
      }
    }
  }, [_c('span', [_vm._v("過去の 社内報も見る")])])])]) : _vm._e()]), _c('section', {
    staticClass: "home__section__4"
  }, [_vm._m(25), _c('div', {
    staticClass: "home__sec__inner home__2"
  }, [_c('p', {
    staticClass: "home__2__txt1 brown",
    domProps: {
      "innerHTML": _vm._s(_vm.moralWord)
    }
  }), _c('button', {
    staticClass: "btn01 -home-style",
    class: _vm.moralUnavailable(),
    attrs: {
      "disabled": _vm.noMoral()
    },
    on: {
      "click": _vm.goMoralStart
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.moralWordBox)
    }
  }, [_vm._v("今月のモラルチェックをはじめる")])]), (_vm.isShopMaster) ? _c('div', {
    staticClass: "mt15"
  }, [_c('p', {
    staticClass: "home__2__txt2"
  }, [_vm._v("店舗長の方は、まだチェックが済んでない方への声かけをお願いしますニャン♪")]), _c('button', {
    staticClass: "btn02 -home-style",
    class: _vm.moralNoAnserUnavailable(),
    attrs: {
      "disabled": _vm.noAnserMoral()
    },
    on: {
      "click": _vm.goMoralNoAnswerList
    }
  }, [(this.getNoanswermoralCount > 0) ? _c('span', [_vm._v("声かけ用リスト"), _c('span', {
    staticClass: "fz15"
  }, [_vm._v("（未チェックの方一覧）")])]) : _c('span', [_vm._v("全員が回答しました！＾＾")])])]) : _vm._e()])]), _c('section', {
    staticClass: "home__section__4"
  }, [_vm._m(26), _c('div', {
    staticClass: "service_vides"
  }, [(_vm.newMovieExists) ? _c('div', [_c('p', [_vm._v("最新動画")]), _c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": _vm.newMovieUrl,
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]) : _vm._e(), (_vm.recommendMovieExists) ? _c('div', [_c('p', [_vm._v("オススメ動画")]), _c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": _vm.recommendMovieUrl,
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]) : _vm._e()]), (_vm.serviceAnswerGetEnd && (_vm.isServiceAnswerExist)) ? _c('div', _vm._l((_vm.serviceQuestions), function(serviceQuestion) {
    return _c('div', {
      staticClass: "home__sec__inner home__1"
    }, [_c('button', {
      staticClass: "btn02 -home-style",
      on: {
        "click": function($event) {
          _vm.goServiceAnswerList(serviceQuestion.service_question_id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(serviceQuestion.title) + "の対象者を確認する")])])])
  }), 0) : _vm._e(), (_vm.serviceAnswerIsOwn.length > 0) ? _c('div', _vm._l((_vm.serviceAnswerIsOwn), function(ownServiceAnswer) {
    return _c('div', {
      staticClass: "home__sec__inner home__1"
    }, [_c('button', {
      staticClass: "btn02 -home-style",
      on: {
        "click": function($event) {
          _vm.goServiceAnswer(ownServiceAnswer.service_question_answer_id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(ownServiceAnswer.title) + "の自己評価を登録する")])])])
  }), 0) : _vm._e()]), (!_vm.isPayrollExcluded) ? _c('section', {
    staticClass: "home__section__3"
  }, [_vm._m(27), _c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_vm._m(28), _c('button', {
    staticClass: "btn01 -home-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goPayrollList
    }
  }, [_c('span', [_vm._v("給与・賞与明細を見る")])])])]) : _vm._e(), _c('section', {
    staticClass: "home__section__1"
  }, [_vm._m(29), _c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_vm._m(30), (_vm.willMustDate) ? _c('button', {
    staticClass: "btn01 -home-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goWillMustEdit
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.willMustDate) + "の"), _c('br'), _vm._v("MUST・WILLを提出する")])]) : _vm._e(), _c('div', {
    class: _vm.willMustDate ? 'mt20' : ''
  }, [_c('button', {
    staticClass: "btn02 -home-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goWillMustList
    }
  }, [_c('span', [_vm._v("あなたのMUST・WILL一覧")])])])])]), _c('section', {
    staticClass: "home__section__3"
  }, [_vm._m(31), _c('div', {
    staticClass: "home__sec__inner"
  }, [_vm._m(32), _c('button', {
    staticClass: "btn02 -home-style secret",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkVideoTerms
    }
  }, [_c('span', [_vm._v("教育マニュアル・研修動画")])])])]), (!_vm.isStepUpExist && _vm.userTypesQuestion) ? _c('section', {
    staticClass: "home__section__4"
  }, [_vm._m(33), _c('div', {
    staticClass: "home__sec__inner home__1"
  }, [_vm._m(34), _c('div', [_c('button', {
    staticClass: "btn02 -home-style",
    on: {
      "click": function($event) {
        _vm.goStepUpQuestionCheck('normal')
      }
    }
  }, [_c('span', [_vm._v("評価項目を確認する")])])])])]) : _vm._e(), _c('section', {
    staticClass: "home__section__4"
  }, [_vm._m(35), _c('div', {
    staticClass: "home__sec__inner home__3"
  }, [_vm._m(36), _c('button', {
    staticClass: "btn01 -home-style",
    on: {
      "click": _vm.goTreatmentSalaryList
    }
  }, [_c('span', [_vm._v("待遇・制度の一覧を見る")])])])]), _c('section', {
    staticClass: "home__section__2"
  }, [_vm._m(37), _c('div', {
    staticClass: "home__sec__inner home__3"
  }, [_vm._m(38), _c('button', {
    staticClass: "btn02 -home-style",
    class: _vm.messageManager(),
    attrs: {
      "disabled": _vm.isShopMaster
    },
    on: {
      "click": _vm.goMessageSendManager
    }
  }, [_vm._m(39)]), _c('p', {
    staticClass: "fz14 mb15"
  }, [_vm._v("店舗長宛のメッセージは、店舗長が開封します。")]), _c('button', {
    staticClass: "btn02 -home-style",
    class: _vm.messageOfficer(),
    attrs: {
      "disabled": _vm.isOfficer
    },
    on: {
      "click": _vm.goMessageSendOfficer
    }
  }, [_vm._m(40)]), _c('p', {
    staticClass: "fz14 mb15"
  }, [_vm._v("本社担当者のみメッセージを開封します。")]), (_vm.isShopMaster || _vm.isOfficer || _vm.isHarassment) ? _c('div', {
    staticClass: "mt15"
  }, [_c('p', {
    staticClass: "home__2__txt2 -top-border",
    domProps: {
      "innerHTML": _vm._s(_vm.messageCheck)
    }
  }), _c('button', {
    staticClass: "btn02 -home-style",
    class: _vm.messageNothing(),
    attrs: {
      "disabled": _vm.notMessage()
    },
    on: {
      "click": _vm.goMessageList
    }
  }, [_c('span', {
    staticClass: "unread"
  }, [_vm._v("メッセージ受信箱"), (_vm.unread()) ? _c('span', {
    staticClass: "unread__mark"
  }, [_vm._v("未読あり")]) : _vm._e()])])]) : _vm._e()])])])]) : _vm._e(), _c('div', {
    staticClass: "gfooter-wrap"
  }, [_c('app-footer')], 1), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "helpModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#helpModal"
    }
  }, [_vm._v("モーダル発火用")]), _vm._m(41), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "videoTermsModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#videoTermsModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "videoTermsModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(42), _vm._m(43), _c('button', {
    staticClass: "btn02 moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.goVideoCategories
    }
  }, [_c('span', [_vm._v("同意して閲覧する")])]), _vm._m(44)])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "stepUpEditModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#stepUpEditModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "stepUpEditModal"
    }
  }, [_c('div', {
    staticClass: "stepup-caution-bg home__step-up-modal__body",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(45), _vm._m(46), _c('button', {
    staticClass: "btn02 -home-style -step-up",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.goStepUpAnswerEdit()
      }
    }
  }, [_c('span', [_vm._v("回答をはじめる")])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "evaluateAnswerEditModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#evaluateAnswerEditModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "evaluateAnswerEditModal"
    }
  }, [_c('div', {
    staticClass: "stepup-caution-bg home__step-up-modal__body",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(47), _vm._m(48), _c('button', {
    staticClass: "btn02 -home-style -step-up",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.goEvaluateAnswerEdit()
      }
    }
  }, [_c('span', [_vm._v("回答をはじめる")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "16px",
      "font-weight": "bold",
      "color": "#5a3d1e",
      "line-height": "31px"
    }
  }, [_vm._v("書類の更新をお願いします")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__1__txt brown"
  }, [_vm._v("更新後の書類を撮影またはファイルで"), _c('br'), _vm._v("提出してニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_stepup.png"),
      "alt": "ステップアップ"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "padding-left": "0px"
    }
  }, [_vm._v("ステップアップ研修に、チャレンジしている"), _c('br'), _vm._v("スタッフがいます。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt15"
  }, [_c('div', [_c('p', {
    staticClass: "home__2__txt2"
  }, [_vm._v("店舗長の方と事務の方は、まだ回答が済んでいない方への声かけをお願いします。")]), _c('button', {
    staticClass: "btn02 -home-style -unavailable",
    attrs: {
      "disabled": "true"
    }
  }, [_c('span', [_vm._v("全員が回答しました！＾＾")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answered"
  }, [_c('p', [_vm._v("提出済")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_evaluate.png"),
      "alt": "人事評価"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt15"
  }, [_c('div', [_c('p', {
    staticClass: "home__2__txt2"
  }, [_vm._v("店舗長の方と事務の方は、まだ回答が済んでいない方への声かけをお願いします。")]), _c('button', {
    staticClass: "btn02 -home-style -unavailable",
    attrs: {
      "disabled": "true"
    }
  }, [_c('span', [_vm._v("全員が回答しました！＾＾")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answered"
  }, [_c('p', [_vm._v("提出済")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_14.png"),
      "alt": "ESmyカード"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__5__txt -type5 fz14 brown"
  }, [_vm._v("感謝の気持ちを"), _c('br'), _vm._v("伝えるんだニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__5__txt -type4 fz14 mt15 brown"
  }, [_vm._v("みんなのありがとうが"), _c('br'), _vm._v("見れるんだにゃん♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__5__txt -type4 fz14 mt15 brown"
  }, [_vm._v("みんなのありがとうが"), _c('br'), _vm._v("見れるんだにゃん♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "thanks brown"
  }, [_vm._v("あなたへのありがとうが"), _c('br'), _vm._v("届いてるにゃん♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ribbon-deco1"
  }, [_c('span', {
    staticClass: "ribbon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ribbon-deco2"
  }, [_c('span', {
    staticClass: "ribbon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_06.png"),
      "alt": "提案！タイラのアイデア帳！"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__1__txt brown"
  }, [_vm._v("日々の業務の中でふと気づいた"), _c('br'), _vm._v("「こうなると素敵だな」を提案してニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_10.png"),
      "alt": "シフト確認・翌月の希望休提出"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__5__txt brown"
  }, [_vm._v("毎月1〜15日の間に、"), _c('br'), _vm._v("翌月の希望休を"), _c('br', {
    staticClass: "for374"
  }), _vm._v("提出してください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__5__txt -type2 fz14 mt15"
  }, [_vm._v("毎月26日以降に、"), _c('br'), _vm._v("翌月のシフトが確定するニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("シフトを確認する"), _c('span', {
    staticClass: "fz15"
  }, [_vm._v("（シフトカレンダー）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_11_2.png"),
      "alt": "最新の社内報"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_moralcheck.png"),
      "alt": "毎月のモラルチェック"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_service.png"),
      "alt": "接客評価"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "16px",
      "font-weight": "bold",
      "color": "#5a3d1e",
      "line-height": "31px"
    }
  }, [_vm._v("給与・賞与明細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__1__txt brown"
  }, [_vm._v("給与・賞与の明細が"), _c('br'), _vm._v("支給日の前日から見られるニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_13.png"),
      "alt": "MUST・WILL"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__1__txt brown"
  }, [_vm._v("12月と6月に、"), _c('br'), _vm._v("MUST・WILLについて考えるニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_training.png"),
      "alt": "門外不出！秘密の研修"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__1__txt brown title__cat1"
  }, [_vm._v("門外不出！"), _c('br'), _vm._v("マル秘の研修なんだニャン♪（社外秘）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_stepup.png"),
      "alt": "ステップアップ"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__5__txt -type2 brown",
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "0px"
    }
  }, [_vm._v("ステップアップ研修に、チャレンジ"), _c('br'), _vm._v("する際の評価項目だニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_15.png"),
      "alt": "社内の待遇・制度一覧"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__7__txt -type2 brown"
  }, [_vm._v("社内のみんなが利用できる待遇と"), _c('br'), _vm._v("制度をまとめてみたニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "home__sec__head"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_08.png"),
      "alt": "メッセージを送る"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "home__3__txt1 brown"
  }, [_vm._v("気軽な一言から、お悩み相談まで！"), _c('br'), _vm._v("なんでも自由に書いてだニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "bold"
  }, [_vm._v("店舗長へ"), _c('span', {
    staticClass: "normal"
  }, [_vm._v("メッセージを送る")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "bold"
  }, [_vm._v("相談・SOS"), _c('span', {
    staticClass: "normal"
  }, [_vm._v("メッセージを送る")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "helpModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h4', {
    staticClass: "heading_01 mb25"
  }, [_vm._v("熱い想いがあって"), _c('br'), _vm._v("社内SNS"), _c('br'), _vm._v("“WONDER WORLD”を"), _c('br'), _vm._v("作ったんだニャン♪")]), _c('div', {
    staticClass: "box_01 help-modal__body__txt -login-done"
  }, [_c('p', [_vm._v("みんな、いつもありがとう！"), _c('br'), _vm._v("お疲れ様ですニャン！")]), _c('p', [_vm._v("タイラニャンは、「タイラベストビート」を、より素敵な会社にしたいんだニャン！")]), _c('p', [_vm._v("そのためには、やっぱりみんなの声をきくのが一番！")]), _c('p', [_vm._v("お客様は勿論、会社のみんなにも、「居心地のいい、素敵な会社だ」と思ってもらえるように、がんばりたいんだニャン♪")]), _c('p', [_vm._v("“WONDER WORLD”、気軽に使ってほしいニャン♪")])]), _c('button', {
    staticClass: "btn01 moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', [_vm._v("閉じる")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "heading_01 mb25 txt__caution"
  }, [_vm._v("社外秘！"), _c('br'), _vm._v("SNS投稿・複製"), _c('br'), _vm._v("厳禁！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_01 help-modal__body__txt -login-done"
  }, [_c('p', [_vm._v("秘密の研修なので、"), _c('br'), _c('span', {
    staticClass: "txt__caution"
  }, [_vm._v("流出厳禁")]), _vm._v("なんだニャン！")]), _c('p', [_vm._v(" （※転写・複製等行った場合には、\n著作物の侵害として法律にのっとり対処するほか、損害賠償の請求も行います）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__close__wrap moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('img', {
    staticClass: "modal__close",
    attrs: {
      "src": require("../images/icon_close_05.png"),
      "alt": "閉じる",
      "width": "24",
      "height": "24"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb25 fz11"
  }, [_c('p', [_vm._v("評価を実施するにあたり、")]), _c('p', {
    staticClass: "home__step-up-modal__txt-red"
  }, [_vm._v("次の3点に留意して評価をお願いいたします。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_01 home__step-up-modal__body__txt"
  }, [_c('div', {
    staticClass: "fz18 brown"
  }, [_c('ol', {
    staticClass: "bold brown fz16"
  }, [_c('li', [_vm._v("好き嫌いや相性といった感情的なものに影響されないようにお願いいたします")]), _c('br'), _c('li', [_vm._v("噂や評判といった外部からの情報に影響されることがないようにお願いいたします")]), _c('br'), _c('li', [_vm._v("本人の成長を願い公平で客観的な評価をお願いいたします")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb25 fz11"
  }, [_c('p', [_vm._v("評価を実施するにあたり、")]), _c('p', {
    staticClass: "home__step-up-modal__txt-red"
  }, [_vm._v("次の3点に留意して評価をお願いいたします。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_01 home__step-up-modal__body__txt"
  }, [_c('div', {
    staticClass: "fz18 brown"
  }, [_c('ol', {
    staticClass: "bold brown fz16"
  }, [_c('li', [_vm._v("好き嫌いや相性といった感情的なものに影響されないようにお願いいたします")]), _c('br'), _c('li', [_vm._v("噂や評判といった外部からの情報に影響されることがないようにお願いいたします")]), _c('br'), _c('li', [_vm._v("本人の成長を願い公平で客観的な評価をお願いいたします")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-607d14fc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/home.pug
// module id = 1416
// module chunks = 1